import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=239cfb08"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"
import style0 from "../assets/css/offer.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/offer-mobile.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports